/**
 * Where a fetched list stands. A list that has not answered yet is `loading`,
 * not empty: screens render their empty message only once the data is `ready`.
 */
export type LoadStatus = 'loading' | 'error' | 'ready';

/**
 * Resolve a list's status from the flags its hook keeps. Data already on
 * screen wins over a later failed refresh, so a background poll that fails
 * does not replace rows the user is looking at with an error.
 */
export function resolveLoadStatus({
  loaded,
  error,
  hasData = false,
}: {
  /** The first fetch finished (successfully or not). */
  loaded: boolean;
  /** The last fetch failed. */
  error?: unknown;
  /** Rows from an earlier successful fetch are on screen. */
  hasData?: boolean;
}): LoadStatus {
  if (hasData) return 'ready';
  if (error) return 'error';
  return loaded ? 'ready' : 'loading';
}
